import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.262 2.387h-1.32a2.087 2.087 0 0 0-3.89 0h-1.32A2.719 2.719 0 0 0 2.022 5.1v7.14a2.719 2.719 0 0 0 2.71 2.71H8v-1.503H4.732a1.206 1.206 0 0 1-1.21-1.21V5.1a1.2 1.2 0 0 1 1.11-1.2v1.23a.749.749 0 0 0 .75.75h5.23a.755.755 0 0 0 .75-.75V3.9a1.2 1.2 0 0 1 1.12 1.2V8h1.5V5.1a2.721 2.721 0 0 0-2.72-2.713Zm-5.13 1.5h.53a.755.755 0 0 0 .75-.75.585.585 0 0 1 1.17 0 .749.749 0 0 0 .75.75h.53v.49h-3.73v-.49Z M14.683 12.964a.75.75 0 0 0 .002-.575.744.744 0 0 0-.695-.462h-.83v-.85a.75.75 0 1 0-1.5 0v.85h-.84a.75.75 0 1 0 0 1.5h.84v.84a.75.75 0 1 0 1.5 0v-.84h.83a.75.75 0 0 0 .693-.463ZM5 8h6v1H5V8Zm4 2H5v1h4v-1Z';
const draw24px =
  'M20.75 7v6h-1.5V7A2.25 2.25 0 0 0 17 4.75h-.25V7a.75.75 0 0 1-.75.75H8A.75.75 0 0 1 7.25 7V4.75H7A2.25 2.25 0 0 0 4.76 7v10.91A2.25 2.25 0 0 0 7 20.16h7v1.5H7a3.76 3.76 0 0 1-3.75-3.75V7A3.76 3.76 0 0 1 7 3.25h2.3a2.79 2.79 0 0 1 5.38 0H17A3.75 3.75 0 0 1 20.75 7Zm-12-2.25v1.54h6.5V4.75H14a.76.76 0 0 1-.71-.75 1.29 1.29 0 1 0-2.58 0 .75.75 0 0 1-.75.75H8.75ZM20.32 18.9H22a.75.75 0 1 1 0 1.5h-1.68v1.7a.75.75 0 1 1-1.5 0v-1.7h-1.67a.75.75 0 1 1 0-1.5h1.67v-1.69a.75.75 0 1 1 1.5 0v1.69Z M16 11v1.5H8V11h8Zm-2 4H8v1.5h6V15Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ClipboardNewReportIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'clipboardNewReport')) as IconWithRender;

ClipboardNewReportIcon.displayName = 'ClipboardNewReportIcon';
ClipboardNewReportIcon.propTypes = Icon.propTypes;
ClipboardNewReportIcon.renderIcon = (props) => (
  <ClipboardNewReportIcon {...props} />
);
export default ClipboardNewReportIcon;
